/**
 * @file Purchase PPD PhotoItem Container.
 */

import { connect } from 'react-redux';
import compose from 'lodash.flowright';

import PurchasePpdPhotosPhotoItem from '../../components/purchase/PurchasePpdPhotosPhotoItem';

const mapStateToProps = ({ ppdPurchase }) => ({
  cart: ppdPurchase.cart,
  address: ppdPurchase.address,
});

export default compose(connect(mapStateToProps))(PurchasePpdPhotosPhotoItem);
